import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BoundingRegion } from '@/interface/pdfTypes';

export interface KeyValueState {
  data: Record<string, KeyValueValue>; // use defined value type instead of any
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
}

export interface KeyValuePair {
  key: string;
  value: any;
  bounding_regions: BoundingRegion[];
}

export interface KeyValueValue {
  value: any;
  bounding_regions: BoundingRegion[];
}

const initialState: KeyValueState = {
  data: {},
  status: 'idle',
  error: null,
};

const keyValueSlice = createSlice({
  name: 'keyValue',
  initialState,
  reducers: {
    addKeyValue: (state, action: PayloadAction<KeyValuePair>) => {
      state.data[action.payload.key] = {
        value: action.payload.value,
        bounding_regions: action.payload.bounding_regions,
      };
    },
    updateKeyValue: (state, action: PayloadAction<{ key: string; value: KeyValuePair }>) => {
      if (state.data.hasOwnProperty(action.payload.key)) {
        state.data[action.payload.key] = action.payload.value;
      }
    },
    deleteKeyValue: (state, action: PayloadAction<string>) => {
      delete state.data[action.payload];
    },
  },
});

export const { addKeyValue, updateKeyValue, deleteKeyValue } = keyValueSlice.actions;
export default keyValueSlice.reducer;
